import { createSelector } from 'reselect'

import { selectGroupConfig } from './selectGroupConfig'

export const selectDefaultAccount = createSelector([selectGroupConfig], (groupConfig) =>
  groupConfig.getIn(['defaults', 'account'])
)
